import {isBrowser} from '@financial/finance-env';

export type TStorageType = 'local' | 'session';

class BaseStorage {
    protected storage;
    constructor(storage?: Storage) {
        this.storage = storage;
    }
    get(key: string): any {
        let rawItem;

        try {
            rawItem = this.storage?.getItem(key);

            if (!rawItem) {
                return null;
            }

            /**
             * @description storage의 값이 JSON으로 변경이 안되는 경우 예외처리
             * @see https://developer.mozilla.org/ko/docs/Web/JavaScript/Reference/Global_Objects/JSON/parse#%EC%98%88%EC%99%B8
             */
            return JSON.parse(rawItem);
        } catch (e) {
            return rawItem || null;
        }
    }
    set(key: string, value: any) {
        try {
            this.storage?.setItem(key, typeof value === 'object' && value !== null ? JSON.stringify(value) : value);
        } catch (e) {}
    }
    remove(key: string) {
        try {
            this.storage?.removeItem(key);
        } catch (e) {}
    }
    clear() {
        try {
            this.storage?.clear();
        } catch (e) {}
    }
}

const storages: {local?: BaseStorage; session?: BaseStorage; server: BaseStorage} = {
    server: new BaseStorage(),
};

const storageFactory = (type: TStorageType) => {
    switch (type) {
        case 'local':
            return new BaseStorage(window.localStorage);
        case 'session':
            return new BaseStorage(window.sessionStorage);
    }
};

export const getStorage = (type: TStorageType) => {
    // SSR 시 예외처리
    if (!isBrowser) {
        return storages.server;
    }
    if (!storages[type]) {
        storages[type] = storageFactory(type);
    }

    return storages[type] as BaseStorage;
};
